// extracted by mini-css-extract-plugin
export default {"modalBody":"gGk3Z","modalTextArea":"higQ2 oeY6d cmg3P d1csx"};